// src/frontend/js/modern/ui/popup-handler.js

import { hidePopup } from '../lib/popup-lite.js';

export class PopupHandler {
	constructor() {
		this._boundEvents = [];
	}

	init() {
		this._bindPopupClose();
		this._bindPopupFormSubmit();
	}

	_bindPopupClose() {
		const onClick = (e) => {
			const closeBtn = e.target.closest('.wlfmc-popup-close');
			if (!closeBtn) return;
			e.preventDefault();
			e.stopPropagation();
			const popupId = closeBtn.dataset.popupId;
			if (!popupId) return;
			const popup = document.getElementById(popupId);
			if (!popup) return;
			hidePopup(popup);
		};
		document.addEventListener('click', onClick, true);
		this._boundEvents.push({ event: 'click', handler: onClick, options: true });
	}

	_bindPopupFormSubmit() {
		const onSubmit = (e) => {
			if (e.target.closest('.wlfmc-popup-form')) {
				e.preventDefault();
				return false;
			}
		};
		document.addEventListener('submit', onSubmit, true);
		this._boundEvents.push({ event: 'submit', handler: onSubmit, options: true });
	}

	destroy() {
		this._boundEvents.forEach(({ event, handler, options }) => {
			document.removeEventListener(event, handler, options);
		});
		this._boundEvents = [];
	}
}
